(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(98133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./sentry.client.config.ts + 105 modules
var sentry_client_config = __webpack_require__(33402);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./src/components/shared/CardsList/index.tsx + 1 modules
var CardsList = __webpack_require__(8122);
// EXTERNAL MODULE: ./src/components/shared/Hero/index.tsx + 1 modules
var Hero = __webpack_require__(14029);
// EXTERNAL MODULE: ./src/components/shared/OverviewCardsHome/styles.module.scss
var styles_module = __webpack_require__(82002);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/libs/context/index.js
var context = __webpack_require__(58218);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/components/shared/Icon/index.tsx
var Icon = __webpack_require__(81394);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/HaggleModal/HaggleModal.tsx
var HaggleModal = __webpack_require__(88802);
;// CONCATENATED MODULE: ./src/components/shared/OverviewCardsHome/index.tsx















var OverviewCardsHome = function() {
    var ref;
    var guestUser = (0,react.useContext)(context/* AppContext */.I).guestUser;
    var ref1 = (0,react.useState)(false), openModal = ref1[0], setOpenModal = ref1[1];
    var ref2 = (0,react.useState)(false), isLoaded = ref2[0], setIsLoaded = ref2[1];
    var ref3 = (0,react.useState)(false), isGuestUser = ref3[0], setIsGuestUser = ref3[1];
    var ref4 = (0,react.useState)(), hubstpotFields = ref4[0], setHubstpotFields = ref4[1];
    (0,react.useEffect)(function() {
        var fetchHubspotData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("/api/hubspot-cms/homeOverviewCards-cms")
                            ];
                        case 1:
                            data = _state.sent().data;
                            setHubstpotFields(data.fieldPlaceholders);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (axios/* default.isAxiosError */.Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot banner:", error.message);
                            } else {
                                console.error("Error fetching HubSpot banner:", error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchHubspotData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchHubspotData();
    }, []);
    (0,react.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    (0,react.useEffect)(function() {
        setIsLoaded(true);
    }, []);
    (0,react.useEffect)(function() {
        var handleClick = function(event) {
            event.preventDefault();
            setOpenModal(true);
        };
        var link = document.getElementById("link");
        link === null || link === void 0 ? void 0 : link.addEventListener("click", handleClick);
        return function() {
            link === null || link === void 0 ? void 0 : link.removeEventListener("click", handleClick);
            setIsLoaded(false);
        };
    }, [
        isLoaded
    ]);
    if (isGuestUser && (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.AllowedUsers) === "Registered") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!isGuestUser && (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.AllowedUsers) === "Guest") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var router = (0,next_router.useRouter)();
    var isMovePage = (router === null || router === void 0 ? void 0 : router.asPath) === "/move" ? true : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container ".concat((styles_module_default()).mainContainer),
        style: {
            backgroundColor: (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.cardsBackgroundColor) ? hubstpotFields.cardsBackgroundColor : "white"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).moveTitle,
                children: [
                    (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bolder-lg pt-40 pb-18 text-darkGray ".concat((styles_module_default()).title),
                        children: (0,html_react_parser/* default */.ZP)(hubstpotFields.title || "")
                    }),
                    (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.subTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "font-regular-h5 text-darkGray ".concat((styles_module_default()).subtitle),
                        children: (0,html_react_parser/* default */.ZP)(hubstpotFields.subTitle || "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                gutter: 16,
                justify: "space-between",
                className: classnames_default()((styles_module_default()).cardsContainer),
                children: (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.cards) && ((ref = hubstpotFields.cards) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(col/* default */.Z, {
                        className: isMovePage ? "".concat((styles_module_default()).cardSection) : "",
                        span: 24,
                        lg: isMovePage ? 6 : 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: isMovePage ? "#" : item === null || item === void 0 ? void 0 : item.linkUrl,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (styles_module_default()).cardItem,
                                onClick: function(event) {
                                    if (isMovePage) {
                                        event.preventDefault();
                                        setOpenModal(true);
                                    } else {
                                        return;
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-15",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()(isMovePage ? "font-bold-h3" : "font-bolder-h2 mb-18", (styles_module_default()).cardTitle),
                                                children: isMovePage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    className: "font-bold-h3 ".concat(isMovePage ? (styles_module_default()).moveCardTitle : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            height: 24,
                                                            src: "https://22338452.fs1.hubspotusercontent-na1.net/hubfs/22338452/logos_storefront/quote-icon.svg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item === null || item === void 0 ? void 0 : item.title
                                                        })
                                                    ]
                                                }) : item === null || item === void 0 ? void 0 : item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: classnames_default()("mb-16", (styles_module_default()).cardDescription, isMovePage ? (styles_module_default()).moveCards : ""),
                                                children: item === null || item === void 0 ? void 0 : item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: classnames_default()((styles_module_default()).cardLink, "mb-4 text-oxfordBlue font-bold-base lh-sm"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item === null || item === void 0 ? void 0 : item.linkText
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "rightArrow",
                                        classesName: (styles_module_default()).rightArrow,
                                        color: "#000000",
                                        width: 10,
                                        height: 18
                                    })
                                ]
                            })
                        })
                    }, index);
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HaggleModal/* default */.Z, {
                title: "Contact Us",
                subTitle: "Let us share how Move can unlock your logistics",
                isModalOpen: openModal,
                setIsModalOpen: setOpenModal
            })
        ]
    });
};
/* harmony default export */ var shared_OverviewCardsHome = (OverviewCardsHome);

// EXTERNAL MODULE: ./src/components/shared/SimplySellMore/index.tsx
var SimplySellMore = __webpack_require__(63177);
// EXTERNAL MODULE: ./src/components/shared/CustomCarousel/index.tsx + 5 modules
var CustomCarousel = __webpack_require__(28865);
// EXTERNAL MODULE: ./src/components/shared/RequestProduct/index.tsx
var RequestProduct = __webpack_require__(65971);
// EXTERNAL MODULE: ./src/components/shared/PromotionHomePageBanner/styles.module.scss
var PromotionHomePageBanner_styles_module = __webpack_require__(72800);
var PromotionHomePageBanner_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionHomePageBanner_styles_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/Button/index.tsx
var Button = __webpack_require__(5172);
;// CONCATENATED MODULE: ./src/components/shared/PromotionHomePageBanner/index.tsx













var PromotionHomePageBanner = function() {
    var ref, ref1;
    var guestUser = (0,react.useContext)(context/* AppContext */.I).guestUser;
    var ref2 = (0,react.useState)(false), isGuestUser = ref2[0], setIsGuestUser = ref2[1];
    var ref3 = (0,react.useState)(false), openModal = ref3[0], setOpenModal = ref3[1];
    var router = (0,next_router.useRouter)();
    var isHagglePage = (router === null || router === void 0 ? void 0 : router.asPath) === "/haggle";
    var ref4 = (0,react.useState)(), hubstpotFields = ref4[0], setHubstpotFields = ref4[1];
    (0,react.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    (0,react.useEffect)(function() {
        var fetchHubspotData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("/api/hubspot-cms/homePromotionBanner-cms")
                            ];
                        case 1:
                            data = _state.sent().data;
                            setHubstpotFields(data.fieldPlaceholders);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (axios/* default.isAxiosError */.Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot banner:", error.message);
                            } else {
                                console.error("Error fetching HubSpot banner:", error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchHubspotData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchHubspotData();
    }, []);
    if (isGuestUser && (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.AllowedUsers) === "Registered") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!isGuestUser && (hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.AllowedUsers) === "Guest") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("container bg-white py-40", (PromotionHomePageBanner_styles_module_default()).mainContainer, isHagglePage ? (PromotionHomePageBanner_styles_module_default()).hagglePage : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundColor: hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.backgroundColor
            },
            className: classnames_default()("py-14", (PromotionHomePageBanner_styles_module_default()).bannerContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (PromotionHomePageBanner_styles_module_default()).imgSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(isHagglePage ? (PromotionHomePageBanner_styles_module_default()).hagglePage : "", (PromotionHomePageBanner_styles_module_default()).promoImage),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            unoptimized: true,
                            src: hubstpotFields ? (ref = hubstpotFields.image) === null || ref === void 0 ? void 0 : ref.url : "",
                            alt: hubstpotFields ? (ref1 = hubstpotFields.image) === null || ref1 === void 0 ? void 0 : ref1.altText : "",
                            width: isHagglePage ? 453 : 305,
                            height: isHagglePage ? 304 : 276
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-10 ".concat((PromotionHomePageBanner_styles_module_default()).descBtnContainer),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((PromotionHomePageBanner_styles_module_default()).promoDescriptionContainer, "ms-25"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((PromotionHomePageBanner_styles_module_default()).titleWrapper, "text-oxfordBlue font-bolder-h4 pb-4"),
                                    children: hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((PromotionHomePageBanner_styles_module_default()).promoDescription, "text-oxfordBlue font-bold-sm lh-sm"),
                                    children: hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PromotionHomePageBanner_styles_module_default()).shopButtonWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                theme: "primary",
                                className: classnames_default()((PromotionHomePageBanner_styles_module_default()).btn, "font-bold-base bg-primary m-5"),
                                onClick: function(event) {
                                    if ((router === null || router === void 0 ? void 0 : router.asPath) === "/haggle") {
                                        event.preventDefault();
                                        setOpenModal(true);
                                    } else {
                                        return;
                                    }
                                },
                                href: (router === null || router === void 0 ? void 0 : router.asPath) === "/haggle" ? "" : "/?epallet_signup=true",
                                children: hubstpotFields === null || hubstpotFields === void 0 ? void 0 : hubstpotFields.buttonText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HaggleModal/* default */.Z, {
                            isModalOpen: openModal,
                            setIsModalOpen: setOpenModal
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var shared_PromotionHomePageBanner = (PromotionHomePageBanner);

// EXTERNAL MODULE: ./src/utilities/mapHubspotModules.ts
var mapHubspotModules = __webpack_require__(6451);
;// CONCATENATED MODULE: ./src/pages/index.tsx

















var __N_SSP = true;
function Home(param) {
    var layoutData = param.layoutData, initialHubspotFieldsHero = param.initialHubspotFieldsHero;
    console.log("[Home Component] Received initialHubspotFieldsHero:", JSON.stringify(initialHubspotFieldsHero, null, 2));
    var ref = (0,react.useState)(), hubspotFieldsCardSection1 = ref[0], setHubspotFieldsCardSection1 = ref[1];
    var ref1 = (0,react.useState)(), hubspotFieldsCardSection2 = ref1[0], setHubspotFieldsCardSection2 = ref1[1];
    var ref2 = (0,react.useState)(), hubspotFieldsCardSection3 = ref2[0], setHubspotFieldsCardSection3 = ref2[1];
    var ref3 = (0,react.useState)(), hubspotFieldsCardSection4 = ref3[0], setHubspotFieldsCardSection4 = ref3[1];
    var ref4 = (0,react.useState)(), hubspotFieldsCardSection5 = ref4[0], setHubspotFieldsCardSection5 = ref4[1];
    var ref5 = (0,react.useState)(initialHubspotFieldsHero !== null && initialHubspotFieldsHero !== void 0 ? initialHubspotFieldsHero : undefined), hubspotFieldsHero = ref5[0], setHubspotFieldsHero = ref5[1];
    var ref6 = (0,react.useState)(), hubspotFieldsSimplySellMore = ref6[0], setHubspotFieldsSimplySellMore = ref6[1];
    var ref7 = (0,react.useState)(), hubspotFieldsCarousel1 = ref7[0], setHubspotFieldsCarousel1 = ref7[1];
    var ref8 = (0,react.useState)(), hubspotFieldsCarousel2 = ref8[0], setHubspotFieldsCarousel2 = ref8[1];
    var ref9 = (0,react.useState)(), hubspotFieldsCarousel3 = ref9[0], setHubspotFieldsCarousel3 = ref9[1];
    var ref10 = (0,react.useState)(), hubspotFieldsCarousel4 = ref10[0], setHubspotFieldsCarousel4 = ref10[1];
    var ref11 = (0,react.useState)(), hubspotFieldsCarousel5 = ref11[0], setHubspotFieldsCarousel5 = ref11[1];
    var ref12 = (0,react.useState)(), hubspotFieldsRequestProduct = ref12[0], setHubspotFieldsRequestProduct = ref12[1];
    var ref13 = (0,react.useState)(true), isLoadingBelowFold = ref13[0], setIsLoadingBelowFold = ref13[1];
    (0,react.useEffect)(function() {
        var fetchCardSection1Data = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("/api/hubspot-cms/cardSection-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "cardSectionWelcomeBack")))
                            ];
                        case 1:
                            data = _state.sent().data;
                            setHubspotFieldsCardSection1(data.fieldPlaceholders);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (axios/* default.isAxiosError */.Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot CardSection1 data :", error.message);
                            } else {
                                console.error("Error fetching HubSpot CardSection1 data:", error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCardSection1Data() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!hubspotFieldsCardSection1) {
            fetchCardSection1Data();
        }
    }, [
        hubspotFieldsCardSection1
    ]);
    var DELAY_MS = 2000;
    var createDelayedFetcher = function(setter, apiPath, stateValue, debugName) {
        if (!stateValue) {
            var timerId = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log("[Delayed Fetch] Starting fetch for ".concat(debugName));
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get(apiPath)
                            ];
                        case 2:
                            data = _state.sent().data;
                            setter(data.fieldPlaceholders);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            if (axios/* default.isAxiosError */.Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot ".concat(debugName, " data :"), error.message);
                            } else {
                                console.error("Error fetching HubSpot ".concat(debugName, " data:"), error);
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }), DELAY_MS);
            return function() {
                return clearTimeout(timerId);
            };
        }
        return function() {};
    };
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCardSection2, "/api/hubspot-cms/cardSection-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "cardSectionTopCategories")), hubspotFieldsCardSection2, "CardSection2");
    }, [
        hubspotFieldsCardSection2
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCardSection3, "/api/hubspot-cms/cardSection-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "cardSectionShopByBrands1")), hubspotFieldsCardSection3, "CardSection3");
    }, [
        hubspotFieldsCardSection3
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCardSection4, "/api/hubspot-cms/cardSection-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "cardSectionShopByBrands2")), hubspotFieldsCardSection4, "CardSection4");
    }, [
        hubspotFieldsCardSection4
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCardSection5, "/api/hubspot-cms/cardSection-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "cardSectionShopByBusiness")), hubspotFieldsCardSection5, "CardSection5");
    }, [
        hubspotFieldsCardSection5
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsSimplySellMore, "/api/hubspot-cms/homeSymplySellMore-cms", hubspotFieldsSimplySellMore, "SimplySellMore");
    }, [
        hubspotFieldsSimplySellMore
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCarousel1, "/api/hubspot-cms/carrousel-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "carouselFeaturedProductsHome")), hubspotFieldsCarousel1, "Carousel1");
    }, [
        hubspotFieldsCarousel1
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCarousel2, "/api/hubspot-cms/carrousel-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "carouselHaggleProducts")), hubspotFieldsCarousel2, "Carousel2");
    }, [
        hubspotFieldsCarousel2
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCarousel3, "/api/hubspot-cms/carrousel-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "CarouselPopularThisMonth")), hubspotFieldsCarousel3, "Carousel3");
    }, [
        hubspotFieldsCarousel3
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCarousel4, "/api/hubspot-cms/carrousel-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "CarouselFeaturedProduct2")), hubspotFieldsCarousel4, "Carousel4");
    }, [
        hubspotFieldsCarousel4
    ]);
    (0,react.useEffect)(function() {
        return createDelayedFetcher(setHubspotFieldsCarousel5, "/api/hubspot-cms/carrousel-cms?rowId=".concat((0,mapHubspotModules/* getResourceId */.f)("rows", "CarouselRecentlyViewed")), hubspotFieldsCarousel5, "Carousel5");
    }, [
        hubspotFieldsCarousel5
    ]);
    (0,react.useEffect)(function() {
        if (!hubspotFieldsRequestProduct) {
            var timerId = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log("[Delayed Fetch] Starting fetch for RequestProduct");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                axios/* default.get */.Z.get("/api/hubspot-cms/requestProduct-cms")
                            ];
                        case 2:
                            data = _state.sent().data;
                            setHubspotFieldsRequestProduct(data.fieldPlaceholders);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            if (axios/* default.isAxiosError */.Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot RequestProduct data :", error.message);
                            } else {
                                console.error("Error fetching HubSpot RequestProduct data:", error);
                            }
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoadingBelowFold(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }), DELAY_MS + 200);
            return function() {
                return clearTimeout(timerId);
            };
        }
        return function() {};
    }, [
        hubspotFieldsRequestProduct
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Epallet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Shop at EPallet for the widest selection and best variety."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com",
                        crossOrigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        children: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer',".concat("GTM-NV5M57F", ");\n          ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                style: {
                    padding: 0
                },
                role: "main",
                children: [
                    hubspotFieldsCardSection1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsList/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCardSection1)),
                    hubspotFieldsHero && hubspotFieldsHero.image && hubspotFieldsHero.mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                        image: hubspotFieldsHero.image,
                        mobileImage: hubspotFieldsHero.mobileImage,
                        heading: hubspotFieldsHero.heading,
                        subHeading: hubspotFieldsHero.subHeading,
                        linkLabel: hubspotFieldsHero.linkLabel,
                        linkLabelMobile: hubspotFieldsHero.linkLabelMobile,
                        linkUrl: hubspotFieldsHero.linkUrl,
                        AllowedUsers: hubspotFieldsHero.AllowedUsers,
                        promotionID: hubspotFieldsHero.promotionID
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_OverviewCardsHome, {}),
                    hubspotFieldsCardSection2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsList/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCardSection2)),
                    hubspotFieldsSimplySellMore && hubspotFieldsSimplySellMore.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimplySellMore/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsSimplySellMore)),
                    hubspotFieldsCarousel1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCarousel1)),
                    hubspotFieldsCardSection3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsList/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCardSection3)),
                    hubspotFieldsCardSection4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsList/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCardSection4)),
                    hubspotFieldsCarousel3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCarousel3)),
                    hubspotFieldsCarousel4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCarousel4)),
                    hubspotFieldsCardSection5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsList/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCardSection5)),
                    hubspotFieldsCarousel5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCarousel/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsCarousel5)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_PromotionHomePageBanner, {}),
                    hubspotFieldsRequestProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestProduct/* default */.Z, (0,_object_spread/* default */.Z)({}, hubspotFieldsRequestProduct))
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getResourceId; }
/* harmony export */ });
var hubspotModules = {
    // Module IDs
    modules: {
        aboutUsBrandBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183936144141
            staging: "183936144141",
            // Production: https://app.hubspot.com/design-manager/22338452/modules/185160566914
            production: "185160566914"
        },
        aboutUsHeroBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183935004743
            staging: "183935004743",
            // Production: https://app.hubspot.com/design-manager/22338452/modules/185162230181
            production: "185162230181"
        },
        aboutUsJoinOurTeamSection1: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183935915051
            staging: "183935915051",
            // Production: https://app.hubspot.com/design-manager/22338452/modules/185162627456
            production: "185162627456"
        },
        aboutUsJoinOurTeamSection2: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183981812787
            staging: "183981812787",
            // Production: https://app.hubspot.com/design-manager/22338452/modules/185161326001
            production: "185161326001"
        },
        aboutUsOverviewCards: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184038911836
            staging: "184038911836",
            // Production: https://app.hubspot.com/design-manager/22338452/modules/185162231210
            production: "185162231210"
        },
        benefitsCards: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184607668396
            staging: "184607668396",
            production: "185161528085"
        },
        brands: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183933873983
            staging: "183933873983",
            production: "185161527731"
        },
        brandsCategoryBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183933230467
            staging: "183933230467",
            production: "185162231418"
        },
        contactUs: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184402401357
            staging: "184402401357",
            production: "185162231666"
        },
        featuredVendors: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184542032977
            staging: "184542032977",
            production: "185161528886"
        },
        footer: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183978432146
            staging: "183978432146",
            production: "183741507181"
        },
        haggleMobileSection: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184649395998
            staging: "184649395998",
            production: "185162231671"
        },
        hero: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183934922491
            staging: "184722096776",
            production: "185161528102"
        },
        homeOverviewCards: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184722096948
            staging: "184722096948",
            production: "185161327384"
        },
        homePromotionBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184723369042
            staging: "184723369042",
            production: "185161327385"
        },
        homeSimplySellMore: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184721062976
            staging: "184721062976",
            production: "185162231690"
        },
        mixedPalletBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184541010010
            staging: "184541010010",
            production: "185162232333"
        },
        orderConfirmation: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184368455241
            staging: "184368455241",
            production: "185161529424"
        },
        press: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183931213751
            staging: "183931213751",
            production: "183793116798"
        },
        promotionHaggleBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184649539204
            staging: "184649539204",
            production: "185161329542"
        },
        promotionHomeBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184361902736
            staging: "184361902736",
            production: "184359974692"
        },
        requestProduct: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184723369003
            staging: "184723369003",
            production: "185162231689"
        },
        testimonial: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/183978432165
            staging: "183978432165",
            production: "183710298433"
        },
        termsAndConditions: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/1184062021983
            staging: "184062021983",
            production: "183947038546"
        },
        HaggleBanner: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184607157813
            staging: "184607157813",
            production: "185161528083"
        },
        maintenance: {
            // Staging: https://app.hubspot.com/design-manager/39592841/modules/184607157813
            staging: "185520843014",
            production: "185557289857"
        }
    },
    // Table IDs
    tables: {
        cardSectionTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105896340
            staging: "105896340",
            production: "106884167"
        },
        carouselTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105227020
            staging: "105227020",
            production: "106884173"
        },
        haggleTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/104409270
            staging: "104409270",
            production: "103996071"
        },
        helpCenterBuyerVendorTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105896340
            staging: "105896718",
            production: "106874199"
        },
        helpCenterFAQTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105896340
            staging: "105897397",
            production: "106884163"
        },
        HelpCenterBannerTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105896340
            staging: "105895973",
            production: "106874197"
        },
        SlickBannerTable: {
            // Staging: https://app.hubspot.com/hubdb/39592841/table/105896340
            staging: "104409269",
            production: "103996069"
        }
    },
    // Row IDs
    rows: {
        cardSectionWelcomeBack: {
            // Staging: Row ID for "Welcome Back"
            staging: "184679121231",
            production: "185164348278"
        },
        cardSectionTopCategories: {
            // Staging: Row ID for "Top Categories"
            staging: "184721198441",
            production: "185164348279"
        },
        cardSectionShopByBrands1: {
            // Staging: Row ID for "Shop by Brands"
            staging: "184721198463",
            production: "185164348280"
        },
        cardSectionShopByBrands2: {
            // Staging: Row ID for "Shop by Brands"
            staging: "184859859315",
            production: "185164348281"
        },
        cardSectionShopByBusiness: {
            // Staging: Row ID for "Shop by Business"
            staging: "184721642530",
            production: "185164348282"
        },
        carouselFeaturedProductsHome: {
            // Staging: Row ID for "Featured Products"
            staging: "184721198471",
            production: "185157637195"
        },
        carouselHaggleProducts: {
            // Staging: Row ID for "Haggle Products"
            staging: "184721198472",
            production: "185157637196"
        },
        CarouselPopularThisMonth: {
            // Staging: Row ID for "Popular This Month"
            staging: "184721198473",
            production: "185157637197"
        },
        CarouselFeaturedProduct2: {
            // Staging: Row ID for "Featured Products"
            staging: "184721198480",
            production: "185157637198"
        },
        CarouselRecentlyViewed: {
            // Staging: Row ID for "Recently Viewed"
            staging: "184721198486",
            production: "185157637199"
        },
        CarouselRecomendedForYouOrder: {
            // Staging: Row ID for "Recomended For You"
            staging: "184373212748",
            production: "185157637194"
        }
    }
};
var getResourceId = function(type, key) {
    var env = "production" || 0;
    var resource = hubspotModules[type][key];
    if (!resource) throw new Error('Resource key "'.concat(key, '" not found in type "').concat(type, '".'));
    return resource[env] || "";
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (hubspotModules)));


/***/ }),

/***/ 82002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__rT80m","cardSection":"styles_cardSection___55QZ","cardItem":"styles_cardItem__KMaiB","rightArrow":"styles_rightArrow___7eYE","moveTitle":"styles_moveTitle__ZBz0R","title":"styles_title__0Fsn3","subtitle":"styles_subtitle__rL5l9","cardsContainer":"styles_cardsContainer__xwDTM","cardLink":"styles_cardLink__btHrP","IconWrapper":"styles_IconWrapper__AohFK","cardTitle":"styles_cardTitle__Wkm9x","cardDescription":"styles_cardDescription__ozbii","moveCards":"styles_moveCards__SxMhe","moveCardTitle":"styles_moveCardTitle__MXi62"};

/***/ }),

/***/ 72800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__dNaVv","hagglePage":"styles_hagglePage__iZSk0","bannerContainer":"styles_bannerContainer__SvxZG","promoImage":"styles_promoImage___J_QF","imgSection":"styles_imgSection__ychWn","promoDescriptionContainer":"styles_promoDescriptionContainer__mTLIc","titleWrapper":"styles_titleWrapper__jHRLv","promoDescription":"styles_promoDescription__t_5F5","descBtnContainer":"styles_descBtnContainer__IM8uX","shopButtonWrapper":"styles_shopButtonWrapper__yLaLj","btn":"styles_btn__36PAz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5935,8996,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);